import React, { useContext } from 'react';
import CardInfo from 'components/CardInfo';
import { StorageLocationContext } from 'screens/YieldV2/StorageLocations/context/StorageLocationProvider';
import formatStorageValue from 'screens/YieldV2/StorageLocations/helpers/formatStorageValue';

const StorageFlat = () => {
  const {
    state: { data = [], selectedId }
  } = useContext(StorageLocationContext);
  const selected = data.find(storage => storage.id === selectedId);
  if (!selected?.capacity || selected?.totalStoredLoadUnit === 'lb') {
    return (
      <div className="flex">
        <div className="w-1/2 pr-4">
          <CardInfo label="Shape" value={selected?.shape} />
          <CardInfo
            label="Length"
            value={formatStorageValue(selected?.length, 'ft')}
          />
          <CardInfo
            label="Height"
            value={formatStorageValue(selected?.height, 'ft')}
          />
        </div>

        <div className="w-1/2 pl-4">
          <CardInfo
            label="Capacity"
            value={
              selected?.capacity
                ? formatStorageValue(selected?.capacity, 'bu')
                : null
            }
          />
          <CardInfo
            label="Width"
            value={formatStorageValue(selected?.width, 'ft')}
          />
          <CardInfo
            label="Volume"
            value={formatStorageValue(selected?.volume, 'cu. ft')}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <div className="w-1/2 pr-4">
        <CardInfo label="Shape" value={selected?.shape} />
        <CardInfo
          label="Width"
          value={formatStorageValue(selected?.width, 'ft')}
        />
        <CardInfo
          label="Volume"
          value={formatStorageValue(selected?.volume, 'cu. ft')}
        />
      </div>

      <div className="w-1/2 pl-4">
        <CardInfo
          label="Length"
          value={formatStorageValue(selected?.length, 'ft')}
        />
        <CardInfo
          label="Height"
          value={formatStorageValue(selected?.height, 'ft')}
        />
      </div>
    </div>
  );
};

export default StorageFlat;
